export default __webpack_public_path__ + "static/media/Didot_Medium.1ac913d9.ttf";